import { Component, OnInit} from '@angular/core';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-cheque-create',
  	templateUrl: './chequeCreate.component.html',
  	styleUrls: ['./chequeCreate.component.scss']
})

export class ChequeCreateComponent implements OnInit{
	public message:string = '';
	sigla = SYSCONF_SIGLA;
	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.financeiro_cheque.includes("CRIAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
}